/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppConfig } from './app/app.config'
import { AppModule } from './app/app.module'

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    const appConfig = moduleRef.injector.get(AppConfig)
    return appConfig.load().then(() => appConfig.loadTranslations())
  })
  .catch((err) => console.error(err))
